import { initialRequestStatusState, RequestStatusState } from '@portal/shared/store/request-status';
import { TableData } from '@portal/shared/types/api-response.types';
import { Tab, TableState } from '@ui/aos-lib';

import { OrderDirection } from 'src/app/pages/equipment/devices/components/devices.models';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import {
  ConsumptionAnalyticsFieldName,
  ConsumptionAnalyticsTableColumnName,
  IndividualConsumptionsTableItem,
  MeasuringPeriod
} from '../individual-consumption-table.types';
import { FilterModel } from '@portal/shared/components/listing-page/services/listing-page-model/listing-page-filter.types';
import { flowDirectionMultiselectItems } from '@portal/shared/constants/flow-direction.constants';
import { FlowDirection } from '@portal/shared/types/filter.types';

export interface IndividualConsumptionsPayload {
  take?: number;
  skip?: number;
  filters?: Array<{ filterType: string; filteredValues: string[] }>;
  sort?: { columnName: ConsumptionAnalyticsFieldName; orderDirection: OrderDirection };
}

export interface IndividualConsumptionTableState {
  tableData: TableData<IndividualConsumptionsTableItem>;
  tableDataRequest: RequestStatusState;
  tableState: TableState;
  payload: IndividualConsumptionsPayload | null;
  measuringPeriodTabs: Tab[];
  flowDirectionFilter: Pick<FilterModel, 'selected' | 'items'>;
}

export const initialIndividualConsumptionTableState: IndividualConsumptionTableState = {
  tableData: {
    data: [],
    total: 0
  },
  tableDataRequest: initialRequestStatusState,
  tableState: {
    skip: 0,
    take: 25,
    sort: [{ field: ConsumptionAnalyticsTableColumnName.TotalValue, dir: 'desc' }]
  },
  measuringPeriodTabs: [
    {
      title: TranslateRegistry.get.DATEPICKER.PRESET.YESTERDAY,
      isActive: true,
      value: MeasuringPeriod.Yesterday
    },
    {
      title: TranslateRegistry.get.DATEPICKER.PRESET.LAST_MONTH,
      isActive: false,
      value: MeasuringPeriod.LastMonth
    }
  ],
  payload: null,
  flowDirectionFilter: {
    selected: [flowDirectionMultiselectItems.find(item => item.value === FlowDirection.Total)!],
    items: flowDirectionMultiselectItems
  }
};
